import type { ResourceKind } from "../../../../features/Schedule/typings/resource-calendar.types";
import { DetailedServiceBookingData, OrderRequestData } from "../Domain/RemoteOrderRequests.types";
import { isResourceOrderRequest } from "./resolveOrderRequestBookingType.function";

export type OrderRequestDetailSections = {
  isResourceOrder: boolean;
  resourceKind?: ResourceKind;
  showCateringTable: boolean;
  showEquipmentTable: boolean;
  showRoomLayoutTable: boolean;
};

export function resolveOrderRequestDetailSections(
  detail: Pick<
    OrderRequestData,
    | "placeOrZoneType"
    | "resourceKind"
    | "numberOfCaterings"
    | "numberOfBookableEquipments"
    | "numberOfRoomLayouts"
  > & {
    caterings?: DetailedServiceBookingData["caterings"];
    equipments?: DetailedServiceBookingData["equipments"];
    roomLayouts?: DetailedServiceBookingData["roomLayouts"];
  }
): OrderRequestDetailSections {
  const isResourceOrder = isResourceOrderRequest(detail);
  const cateringCount = detail.caterings?.length ?? detail.numberOfCaterings;
  const equipmentCount = detail.equipments?.length ?? detail.numberOfBookableEquipments;
  const roomLayoutCount = detail.roomLayouts?.length ?? detail.numberOfRoomLayouts;

  if (isResourceOrder) {
    const resourceKind = detail.resourceKind;
    return {
      isResourceOrder: true,
      resourceKind,
      showCateringTable: resourceKind === "catering" || cateringCount > 0,
      showEquipmentTable: resourceKind === "equipment" || equipmentCount > 0,
      showRoomLayoutTable: false
    };
  }

  return {
    isResourceOrder: false,
    showCateringTable: cateringCount > 0,
    showEquipmentTable: equipmentCount > 0,
    showRoomLayoutTable: roomLayoutCount > 0
  };
}

export function resolveOrderRequestDetailListOpen(
  detail: Pick<
    OrderRequestData,
    | "placeOrZoneType"
    | "resourceKind"
    | "numberOfCaterings"
    | "numberOfBookableEquipments"
    | "numberOfRoomLayouts"
  > & {
    caterings?: DetailedServiceBookingData["caterings"];
    equipments?: DetailedServiceBookingData["equipments"];
    roomLayouts?: DetailedServiceBookingData["roomLayouts"];
  }
): { [key: number]: boolean } {
  const sections = resolveOrderRequestDetailSections(detail);

  return {
    0: sections.showCateringTable,
    1: sections.showEquipmentTable,
    2: sections.showRoomLayoutTable
  };
}
